import * as selectors from './userContext.selectors'
import * as asyncActions from './userContext.asynActions'
import slice from './userContext.slice'

export const {
	name,
	actions: { logout, setIsAuthenticated, setUser, setJwtToken },
	reducer,
} = slice

export const { signIn } = asyncActions

export const {
	selectIsAuthenticated,
	selectCurrentUserHasPermissions,
	selectUserContext,
} = selectors
